import { components, DropdownIndicatorProps } from "react-select";
import { GroupBase } from "react-select";

import { AiModelsIcon } from "../../../icons/AiModelsIcon";
import { ISelectCarmaOption } from "../../../Select/types";



export const DropdownIndicatorWithAiIcon = (
  props: DropdownIndicatorProps<ISelectCarmaOption, boolean, GroupBase<ISelectCarmaOption>>
) => (
  <components.DropdownIndicator {...props}>
    <AiModelsIcon />
  </components.DropdownIndicator>
);